import * as Utils from "../utils/Config";
import { AuthContextModel } from "../App";
import { ApiClient } from "./ApiClient";
import { INotifications } from "../models/INotifications";

export class NotificationsApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getNotifications(success: (notifications: INotifications) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/notifications`, success, error, final);
    }
}